import OrderOverview from '@modules/account/components/order-overview';

/**
 * Account Orders Page
 *
 * Displays a list of customer orders with status information.
 */
export default function AccountOrdersPage() {
  return (
    <div className="w-full" data-testid="orders-page-wrapper">
      <OrderOverview />
    </div>
  );
}
